export const EVENT_NAME = {
  BET_ON_MOBILE_MODAL_VIEWED: "Bet On Mobile Modal Viewed",
  BET_ON_MOBILE_MODAL_CTA_CLICKED: "Bet On Mobile Modal CTA Clicked"
};
